<div #dialog></div>

<div>
  <button mat-button mat-dialog-close style="float: right">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content style="clear: both">

  <ejs-tab #TabGrid cssClass="underline-customize">
    <div class="e-tab-header">
      <div ><span style="color:dimgray">PENDING EDIT REQUESTS</span></div>
      <div><span style="color:dimgray">PENDING TRANSFER REQUESTS</span></div>
    </div>

    <div class="e-content">
      <div>
        <ng-template #ChangeTimestampTPL let-change>
          {{change.ChangeTimestamp | date:'MM-dd-yyyy hh:mm'}}
        </ng-template>
        <ng-template #ViewEditTPL let-change>
          <span>
            <button mat-dialog-close mat-stroked-button color="primary" (click)="ViewEdit(change)">Review Changes</button>
          </span>

        </ng-template>

        <ejs-grid
          style="margin-top: 10px;"
          [dataSource]='EditList'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="false"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
        >
          <e-columns>
            <e-column [template]="ViewEditTPL" headerText=''></e-column>
            <e-column [template]="ChangeTimestampTPL" headerText='Request Timestamp'></e-column>
            <e-column field='LabNumber' headerText='Lab Number'></e-column>
            <e-column field='Dept' headerText='Agency'></e-column>
            <e-column field='CaseNumber' headerText='Agency Case Number'></e-column>
          </e-columns>
        </ejs-grid>

      </div>

      <div>
        <ng-template #detailRow let-change>
          <div style="width: 100%;">
            <div style="width: 100%;">
              <button mat-button (click)="PDFViewChange(change)">View Report</button>
              <button mat-button (click)="ProcessChange(change.ChangeID, true)"><mat-icon>done_outline</mat-icon>Approve Change</button>
              <button mat-button color="warn" (click)="ProcessChange(change.ChangeID, false)"><mat-icon>thumb_down_off_alt</mat-icon>Reject Change</button>
            </div>

            <div style="width: 100%;">
              <table style="width: 100%;">
                <thead >
                <tr>
                  <th style="text-align: left;">Field</th>
                  <th style="text-align: left">Current Value</th>
                  <th style="text-align: left">New Value</th>
                  <th style="text-align: left">Reason</th>
                </tr>
                </thead>
                <tbody>

                <tr *ngFor="let c of change.Changes">
                  <td>{{SQLPropertyFancy(c.Property)}}</td>
                  <td>{{c?.OldValue}}</td>
                  <td>{{c?.NewValue}}</td>
                  <td>{{c?.ChangeReason}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
        <ng-template #ReqDateTimeTPL let-change>
          {{change.ReqDateTime | date:'MM-dd-yyyy hh:mm'}}
        </ng-template>
        <ejs-grid
          style="margin-top: 10px;"
          [dataSource]='dataSource'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [detailTemplate]="detailRow"
          [filterSettings]="{type: 'CheckBox'}"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
        >
          <e-columns>
            <e-column field='ItemType' headerText='Record Type'></e-column>
            <e-column [template]="ReqDateTimeTPL" headerText='Request Timestamp'></e-column>
            <e-column field='ReqLab' headerText='Requested Lab'></e-column>
            <e-column field='AssignedLab' headerText='Assigned Lab'></e-column>
          </e-columns>
        </ejs-grid>
      </div>

    </div>
  </ejs-tab>

</div>



